<!-- 筛选词配置 -->
<template>
    <h2 style="color: #fff">筛选词配置</h2>
    <div>
        <!-- 筛选栏 -->
        <el-form :inline="true" v-model="menuselect">
            <!-- 选择类别 -->
            <el-form-item label="">
                <el-select v-model="menuselect.keywordType" filterable clearable placeholder="选择类别">
                    <el-option v-for="item in cateList" :key="item.id" :label="item.descDescribe" :value="item.id" />
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-input v-model="menuselect.descDescribe" clearable placeholder="选择筛选词"> </el-input>
            </el-form-item>

            <el-form-item style="width: 500px">
                <el-button type="primary" @click="getfilterwordcheckList">查询</el-button>
                <el-button type="success" @click="addkeyworddialogVisible = true">新增筛选词</el-button>
                <el-button type="warning" @click="catemaintain">类别维护</el-button>
            </el-form-item>
        </el-form>
        <!-- 数据展示 -->
        <el-table :data="filterwordcheckList">
            <!-- id -->
            <el-table-column v-if="false" label="id" min-width="200px">
                <template #default="scope">
                    {{ scope.row.id }}
                </template>
            </el-table-column>
            <!-- 编号 -->
            <el-table-column label="编号" max-width="200px">
                <template #default="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <!-- 关键字 -->
            <el-table-column label="关键字" min-width="200px">
                <template #default="scope">
                    {{ scope.row.descDescribe }}
                </template>
            </el-table-column>
            <!-- 类别 -->
            <el-table-column label="类别" min-width="200px">
                <template #default="scope">
                    <div style="display: flex">
                        <el-select v-if="scope.row.opercolvisible" style="width: 200px" v-model="scope.row.keywordType"
                            filterable clearable
                            :placeholder="scope.row.keywordTypeName ? scope.row.keywordTypeName : '默认'">
                            <el-option v-for="item in cateList" :key="item.id" :label="item.descDescribe"
                                :value="item.id" />
                        </el-select>
                        <span v-else>{{ scope.row.keywordTypeName ? scope.row.keywordTypeName : "默认" }}</span>
                    </div>
                </template>
            </el-table-column>

            <!-- 操作列 -->
            <el-table-column label="操作" header-align="center" align="center" min-width="200px">
                <template v-slot="scope">
                    <div v-if="scope.row.opercolvisible">
                        <el-button type="warning" @click="updateword(scope.row)"> 确认提交 </el-button>
                        <el-button type="info" @click="cancelupdateword(scope.row)">取消</el-button>
                    </div>
                    <div v-else>
                        <el-button type="primary" @click="changecate(scope.row)"> 修改类别 </el-button>
                        <el-button type="danger" @click="delword(scope.row.id)"> 删除 </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <!-- 页码栏 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
            :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="alltotal">
        </el-pagination>
    </div>

    <!-- 操作的弹窗 -->
    <div>
        <!-- 新增筛选词弹窗 -->
        <el-dialog v-model="addkeyworddialogVisible" title="新增筛选词" draggable :close-on-click-modal="false"
            :rules="addwordrules" width="550px">
            <el-form v-model="addkeywordinfo" label-width="120px">
                <el-row>
                    <el-col>
                        <el-form-item label="选择类别">
                            <el-select v-model="addkeywordinfo.keywordType" filterable clearable remote
                                placeholder="可不选">
                                <el-option v-for="item in cateList" :key="item.id" :label="item.descDescribe"
                                    :value="item.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="descDescribe" label="筛选词">
                            <el-input v-model="addkeywordinfo.descDescribe"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <template v-slot:footer>
                <div class="dialog-footer">
                    <el-button @click="canceladdword">取消</el-button>
                    <el-button type="primary" @click="sendaddword(0)">保存</el-button>
                    <el-button type="primary" @click="sendaddword(0)">保存</el-button>
                </div>
            </template>
        </el-dialog>

        <!-- 新增类别弹窗 -->
        <el-dialog v-model="addcatedialogVisible" title="新增类别" draggable :close-on-click-modal="false" width="550px"
            :align-center="true">
            <el-form v-model="addkeywordinfo" label-width="120px">
                <el-row>
                    <el-col>
                        <el-form-item label="类别名称">
                            <el-input v-model="addkeywordinfo.descDescribe"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <template v-slot:footer>
                <div class="dialog-footer">
                    <el-button @click="canceladdword">取消</el-button>
                    <el-button type="primary" @click="sendaddword(-1)">保存</el-button>
                </div>
            </template>
        </el-dialog>

        <!-- 类别维护弹窗 -->
        <el-dialog v-model="catemaintaindialogTableVisible" title="类别维护" draggable :close-on-click-modal="false"
            width="1000">
            <el-form :inline="true" v-model="menuselect">
                <!-- <el-form-item label="">
                    <el-input v-model="menuselect.descDescribe" clearable placeholder="选择筛选词">
                    </el-input>
                </el-form-item> -->

                <el-form-item style="width: 500px">
                    <!-- <el-button type="primary" @click="getfilterwordcheckList(-1)">查询</el-button> -->
                    <el-button @click="addcatedialogVisible = true" type="success">添加类别</el-button>
                </el-form-item>
            </el-form>

            <el-table :data="cateList" height="500" stripe>
                <el-table-column label="类型id" v-if="false">
                    <template #default="scope">
                        {{ scope.row.keywordType ? scope.row.keywordType : -1 }}
                    </template>
                </el-table-column>
                <el-table-column label="表id" v-if="false">
                    <template #default="scope">
                        {{ scope.row.id }}
                    </template>
                </el-table-column>
                <el-table-column label="编号" width="80px">
                    <template #default="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column label="名称" align="center">
                    <template #default="scope">
                        <div v-if="scope.row.editable">
                            <el-input v-model="scope.row.descDescribe" />
                        </div>
                        <div v-else>
                            {{ scope.row.descDescribe }}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column label="操作" align="center">
                    <template #default="scope">
                        <div v-if="scope.row.editable">
                            <el-button @click="catemaintainupdatesend(scope.row)">确认修改</el-button>
                        </div>
                        <div v-else>
                            <el-button @click="catemaintainupdate(scope.row)" type="primary">修改名称</el-button>
                            <el-button @click="delword(scope.row.id)" type="danger">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import FixedButtons from "@/components/FixedButtons.vue";
import { scrollToTop } from "@/utils/utils";
import axios from "axios";

export default {
    name: "filterwordcheckView",
    components: {
        FixedButtons,
    },
    data() {
        return {
            wwe: "",
            cateInitURL: "/api/DescDescribe/init",
            getfilterwordcheckListURL: "/api/DescDescribe/queryDataByParam",
            sendaddwordURL: "/api/DescDescribe/insert",
            sendupdatewordURL: "/api/DescDescribe/update",
            delwordURL: "/api/DescDescribe/delete",

            props: {
                multiple: true,
                label: "paramValue",
                value: "看后端传来的",
            },

            cateList: [],
            filterwordcheckList: [],
            // 筛选条件
            menuselect: {
                descDescribe: "",
                keywordType: "",
            },

            // 添加筛选词
            addkeywordinfo: {},

            // 当前页码
            pageNo: 1,
            // 默认每页显示条目数
            pageSize: 10,
            // 总数
            alltotal: 1,

            // 新增筛选词弹窗
            addkeyworddialogVisible: false,
            //  类别维护弹窗
            catemaintaindialogTableVisible: false,
            // 新增类别
            addcatedialogVisible: false,

            addwordrules: {
                descDescribe: [{ required: true, message: "请填写筛选词的名称", trigger: "blur" }],
            },
        };
    },
    methods: {
        catemaintainupdate(row) {
            row.editable = true;
            row.keywordType = -1;
        },

        catemaintainupdatesend(row) {
            this.updateword(row);
            row.editable = false;
        },
        // 点击类别维护
        catemaintain() {
            this.catemaintaindialogTableVisible = true;
            this.clearMenuSelect();
            this.getfilterwordcheckList();
        },
        updateword(row) {
            row.opercolvisible = false;
            axios
                .put(
                    this.sendupdatewordURL,
                    {
                        id: row.id,
                        descDescribe: row.descDescribe,
                        keywordType: row.keywordType,
                    },
                    {
                        headers: {
                            satoken: localStorage.sa,
                            "Content-Type": "application/json",
                        },
                    }
                )
                .then((response) => {
                    if (response.data.success) {
                        this.$message({
                            type: "success",
                            message: "操作成功!",
                        });
                    } else {
                        this.$confirm(response.data.data, response.data.message, {
                            confirmButtonText: "确定",
                            type: "error",
                        })
                            .then(() => {
                                // 用户点击了确定
                            })
                            .catch(() => {
                                // 用户点击了取消
                            });
                    }
                    this.getfilterwordcheckList();
                })
                .catch((error) => {
                    console.error("0请求出错:", error); // 处理错误
                });
        },
        // 取消修改关键词
        cancelupdateword(row) {
            row.opercolvisible = false;
            row.keywordType = null;
        },

        changecate(row) {
            row.opercolvisible = true;
        },

        delword(id) {
            this.$confirm("您确定要删除该数据吗?", "提示", {
                type: "warning",
            })
                .then(() => {
                    // 用户点击了确定
                    axios
                        .delete(this.delwordURL, {
                            params: {
                                idList: id,
                            },
                            headers: {
                                satoken: localStorage.sa,
                            },
                        })
                        .then((response) => {
                            // 处理成功响应
                            this.$message({
                                type: "success",
                                message: "操作成功!",
                            });
                            this.nowtabInit();
                        })
                        .catch((error) => {
                            // 处理错误响应
                            console.error("请求失败", error);
                        });
                })
                .catch(() => {
                    // 用户点击了取消
                });
        },

        // 检验有效值
        sendaddwordsubmitForm() {
            this.$refs[this.addkeywordinfo].validate((valid) => {
                if (valid) {
                    alert("submit!");
                } else {
                    return false;
                }
            });
        },

        sendaddword(keyType) {
            let requestData = {
                ...this.addkeywordinfo,
                ...(keyType === -1 ? { keywordType: "-1" } : {}),
            };

            axios
                .post(this.sendaddwordURL, requestData, {
                    headers: {
                        satoken: localStorage.sa,
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    if (response.data.success) {
                        // 处理成功响应
                        this.$message({
                            type: "success",
                            message: "操作成功!",
                        });
                    } else {
                        this.$confirm(response.data.data, response.data.message, {
                            confirmButtonText: "确定",
                            type: "error",
                        })
                            .then(() => {
                                // 用户点击了确定
                            })
                            .catch(() => {
                                // 用户点击了取消
                            });
                    }
                    this.canceladdword();
                    this.nowtabInit();
                })
                .catch((error) => {
                    // 处理错误响应
                    console.error("请求出错:", error);
                });
        },

        // 取消添加筛选词
        canceladdword() {
            this.addkeywordinfo = {};
            this.addkeyworddialogVisible = false;
            this.addcatedialogVisible = false;
        },

        //  标签页初始化
        nowtabInit() {
            this.clearMenuSelect();
            this.getmenuSelect();
            this.getfilterwordcheckList();
        },

        clearMenuSelect() {
            this.menuselect = {};
        },

        getmenuSelect() {
            axios
                .get(this.cateInitURL, {
                    headers: {
                        satoken: localStorage.sa,
                    },
                    params: {},
                })
                .then((res) => {
                    this.cateList = res.data.data;
                })
                .catch((error) => {
                    this.data = error;
                    console.error("获取数据出错:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getfilterwordcheckList(keyType) {
            let requestData = {
                ...this.menuselect,
                ...(keyType === -1 ? { keywordType: "-1" } : {}),
                pageSize: this.pageSize,
                pageNo: this.pageNo,
            };

            axios
                .get(this.getfilterwordcheckListURL, {
                    headers: {
                        satoken: localStorage.sa,
                    },
                    params: requestData,
                })
                .then((res) => {
                    this.filterwordcheckList = res.data.data.result;
                    this.pageNo = res.data.data.pageNo;
                    this.pageSize = res.data.data.pageSize;
                    this.alltotal = res.data.data.total;
                    if (this.filterwordcheckList.length > 0) {
                    } else {
                        this.$message({
                            type: "error",
                            message: "没有相关数据,请重新查询!",
                        });
                    }
                    this.clearMenuSelect();
                })
                .catch((error) => {
                    this.data = error;
                    console.error("获取数据出错:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        // 页面顶部
        _scrollToTop() {
            scrollToTop(this.$refs.scrollableDiv);
        },

        // //改变页数
        handleCurrentChange(val) {
            this.pageNo = val;
            this.getfilterwordcheckList();
        },

        // // 改变条数
        handleSizeChange(val) {
            this.pageSize = val;
            this.getfilterwordcheckList();
        },
    },
    watch: {},
    computed: {},
    created() { },
    mounted() { },
};
</script>

<style lang="scss" scoped>
.el-table .el-table__cell {
    text-align: center;
}

/* 表格样式*/
.el-table {
    justify-content: center;
    --el-table-header-bg-color: rgb(107, 107, 107);
    --el-table-text-color: #000000;
    --el-table-border: 1px solid #ebeef5;
}

.menu {
    padding-right: 12px;
}

.addone {
    width: 100%;
    justify-content: center;
    display: flex;
    background-color: aliceblue;
    border-radius: 0 0 20px 20px;
}

ul {
    padding: 0;

    li {
        list-style-type: none;
        margin-bottom: 15px;
    }
}

.practical-table {
    width: 100%;
    padding: 20px 40px;
    overflow: auto;
    //color: #ffffff;
}

.card {
    background-color: transparent;
    border: 1px solid transparent;
}

.form-control {
    background-color: #ded9d9;
    margin: 0;
}

.thead-dark {
    background-color: #585d6b;
    color: white;
}

:deep(.tiptop) {
    position: relative;
}

:deep(.tiptop .el-icon) {
    color: #ffffff;
    position: absolute;
    top: -53px;
    left: 215px;
}

:deep(.el-pagination > .is-first) {
    color: #ffffff;
}

:deep(.el-pagination__goto) {
    color: #ffffff;
}

:deep(.el-pagination__classifier) {
    color: #ffffff;
}

:deep(.el-pagination) {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

:deep(.el-form-item__content) {
    width: 160px;
}

.el-radio {
    color: #ffffff;
}

:deep(.el-tabs__item) {
    color: #ffffff;
}
</style>
